import WithRender from "../../templates/base/uploadActions.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowPreviewInUpload",
      "getDisableDeleteUploadAfterConnect",
      "getUploadForProductPart"
    ]),
    showDeleteButton: function () {
      return !this.getDisableDeleteUploadAfterConnect;
    }
  },
  methods: {
    ...mapActions([
      "uploadOnPreview",
      "uploadOnDownload",
      "uploadOnViewReport",
      "uploadOnRearrange",
      "uploadOnDelete"
    ]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "useClassName"]
});
